module.exports = __webpack_public_path__ + "img/IN.be27e748.svg";